import { render } from "./DocumentClassView.vue?vue&type=template&id=43e47ddd&scoped=true&ts=true"
import script from "./DocumentClassView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassView.vue?vue&type=script&lang=ts"

import "./DocumentClassView.vue?vue&type=style&index=0&id=43e47ddd&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e47ddd"]])

export default __exports__